import { render, staticRenderFns } from "./ProductLogo.vue?vue&type=template&id=56d9d20b&scoped=true"
import script from "./ProductLogo.vue?vue&type=script&lang=js"
export * from "./ProductLogo.vue?vue&type=script&lang=js"
import style0 from "./ProductLogo.vue?vue&type=style&index=0&id=56d9d20b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d9d20b",
  null
  
)

export default component.exports